// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__8XUbV","copy":"Home_copy__Z9gZx","image":"Home_image__cST27"};